export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DashboardAdmin.vue?vue&type=template&id=196eabab&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/DashboardAdmin.vue?vue&type=template&id=196eabab&scoped=true&
// module id = 959
// module chunks = 0